// Sentry يجب أن يكون أول استيراد لالتقاط الأخطاء مبكراً
import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import { safeSession } from './lib/safeStorage'
import { initCookieConsent } from './lib/tracking/cookieConsent'
import './style.css'

initCookieConsent()

// حفظ UTM params في sessionStorage عند أول تحميل للصفحة
if (typeof window !== 'undefined') {
  const urlParams = new URLSearchParams(window.location.search)
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
  utmParams.forEach(param => {
    const value = urlParams.get(param)
    if (value) {
      try {
        safeSession.setItem(param, value)
      } catch {
        // التخزين غير متاح
      }
    }
  })
}

// Filter out source map errors from console (they don't affect functionality)
if (typeof window !== 'undefined') {
  const originalError = console.error;
  const originalWarn = console.warn;
  
  console.error = (...args: any[]) => {
    const message = args[0]?.toString() || '';
    const fullMessage = args.map(arg => String(arg)).join(' ');
    
    // Ignore source map errors from Tap SDK
    if (
      message.includes('index.js.map') ||
      message.includes('Cross-Origin-Resource-Policy') ||
      message.includes('Source Map loading errors') ||
      (message.includes('Cannot load') && message.includes('.map')) ||
      (message.includes('Cancelled load') && message.includes('.map')) ||
      fullMessage.includes('sdk.tap.company') && fullMessage.includes('.map')
    ) {
      return; // Suppress these errors
    }
    originalError.apply(console, args);
  };
  
  console.warn = (...args: any[]) => {
    const message = args[0]?.toString() || '';
    
    // Ignore viewport warnings
    if (
      message.includes('target-densityDpi') ||
      message.includes('Viewport argument')
    ) {
      return; // Suppress these warnings
    }
    originalWarn.apply(console, args);
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)

